import { Label } from "../../common/GeneralClasses";

export abstract class LabelsMapper<T> {
  abstract get(labels: Label[]): T;

  getLabel(labels: Label[], name: string): Label {
    let value = "";
    labels.forEach((label) => {
      if (label.name === name) {
        value = label.value;
      }
    });
    return new Label(name, value);
  }
}
